export default "__VITE_ASSET__fz7elVE4__"